import type { Option } from '@branchjs/neo-components';
import type { DataAction } from '../../../types/dataAction.type';

export const UPDATE_QR_CODE_LINK_FEATURE = 'UPDATE_QR_CODE_LINK_FEATURE' as const;

export const updateQrCodeLinkFeature = (feature: Option) => ({
  data: { feature },
  type: UPDATE_QR_CODE_LINK_FEATURE,
});

export type UpdateQrCodeLinkFeatureResponseAction = DataAction<typeof UPDATE_QR_CODE_LINK_FEATURE, { feature: Option }>;
